interface Media {
    filename: string;
    path: string;
    sha1?: string;
    originalFilename?: string;
    storageKey?: string;
    type?: MediaType
}

enum MediaType {
    IMAGE,
    VIDEO,
    PDF,
    NONE
}

const imageTypes: string[] = [
    "image/jpeg",
    "image/jpg",
    "image/gif",
    "image/png",
]

const videoTypes: string[] = [
    "video/mp4",
    "video/mkv",
    "video/avi"
]

const PDFTypes: string[] = [
  "application/pdf",
  "application/x-pdf",   // optional legacy
  "application/acrobat", // optional legacy
];

export { Media, MediaType, imageTypes, videoTypes, PDFTypes };